import React from "react";
import { WifiOff, RefreshCw } from "lucide-react";
import { APP } from "@/constants/testIds";

export const OfflineBanner = ({ online, pending }) => {
  if (online && pending === 0) return null;
  return (
    <div
      data-testid={APP.offlineBanner}
      className="w-full bg-[#1F2E4D] text-white"
      role="status"
      aria-live="polite"
    >
      <div className="max-w-2xl mx-auto px-6 sm:px-8 py-2.5 flex items-center gap-3 text-sm">
        {online ? (
          <RefreshCw className="w-4 h-4 shrink-0 animate-spin" aria-hidden />
        ) : (
          <WifiOff className="w-4 h-4 shrink-0" aria-hidden />
        )}
        <p className="leading-snug">
          {online ? (
            <>
              Back online.{" "}
              <span data-testid={APP.pendingSyncCount}>
                Syncing {pending} saved request{pending === 1 ? "" : "s"}…
              </span>
            </>
          ) : (
            <>
              You are currently offline.{" "}
              {pending > 0 ? (
                <span data-testid={APP.pendingSyncCount}>
                  {pending} request{pending === 1 ? "" : "s"} saved on this
                  device — we'll send {pending === 1 ? "it" : "them"} the moment
                  your connection returns.
                </span>
              ) : (
                "The page will keep working from cache."
              )}
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default OfflineBanner;
